declare namespace $ {

	export class $shm_hitalama_map_widget_float_settings_text_md extends $shm_hitalama_map_widget_float_settings {
		controlled_settings_content( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=md.view.tree.d.ts.map